import type { FunctionComponent, ReactNode } from 'react';
import { useMemo, useReducer } from 'react';

import AgronomyAgreementCropsContext from './AgronomyAgreementCropsContext';
import { getActions } from './actions';
import { initialState, reducer } from './reducer';
import * as selectors from './selectors';

const AgronomyAgreementCropsProvider: FunctionComponent<{ children: ReactNode }> = ({
  children,
}) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const actions = useMemo(() => getActions(dispatch), [dispatch]);

  return (
    <AgronomyAgreementCropsContext.Provider value={{ actions, selectors, state }}>
      {children}
    </AgronomyAgreementCropsContext.Provider>
  );
};

export default AgronomyAgreementCropsProvider;
